import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_SERVER_URL}/api/v1/communications`;

/** One address the business can no longer reach, and why. */
export interface UnsubscribedRow {
  email: string;
  bcustomerId: string | null;
  firstName: string | null;
  lastName: string | null;
  companyName: string | null;
  /** 'opted-out' = they asked us to stop. 'suppressed' = we cannot deliver. */
  kind: "opted-out" | "suppressed";
  reason: string;
  source: string | null;
  at: string | null;
}

export interface UnsubscribedPage {
  rows: UnsubscribedRow[];
  total: number;
  limit: number;
  offset: number;
}

export const getUnsubscribed = async (params: {
  search?: string;
  limit: number;
  offset: number;
}): Promise<UnsubscribedPage> => {
  const response = await axios.get(`${BASE_URL}/unsubscribed`, { params });
  return response.data.data;
};

/**
 * The CSV is built by the server from the same query, so an export always
 * matches what the page shows rather than only the rows currently loaded.
 */
export const unsubscribedCsvUrl = (search?: string): string => {
  const q = new URLSearchParams({ format: "csv" });
  if (search) {
    q.set("search", search);
  }
  return `${BASE_URL}/unsubscribed?${q.toString()}`;
};
